// Static email DNS records a client adds for Remi's email domain (Option A of
// Remi Email Domain Setup). Same SendGrid records the old IDX stage showed;
// hosts sit under the `aimail` subdomain of the client's domain.

export interface EmailDnsRecord {
  type: 'CNAME' | 'TXT';
  /** Part of the host before the client's domain. */
  hostPrefix: string;
  /** Full host, e.g. `s1._domainkey.aimail.abcrealty.com`. */
  host: string;
  value: string;
}

const RECORDS: Omit<EmailDnsRecord, 'host'>[] = [
  {
    type: 'CNAME',
    hostPrefix: 's1._domainkey.aimail',
    value: 's1.domainkey.u47933949.wl200.sendgrid.net',
  },
  { type: 'CNAME', hostPrefix: 'mail.aimail', value: 'u47933949.wl200.sendgrid.net' },
  {
    type: 'CNAME',
    hostPrefix: 's2._domainkey.aimail',
    value: 's2.domainkey.u47933949.wl200.sendgrid.net',
  },
  { type: 'TXT', hostPrefix: '_dmarc', value: 'v=DMARC1; p=none' },
];

export const getEmailDnsRecords = (domain: string): EmailDnsRecord[] =>
  RECORDS.map((record) => ({ ...record, host: `${record.hostPrefix}.${domain}` }));
